export default "__VITE_ASSET__xQ7GlEPB__"